import React from 'react';

const Spinner = () => (
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-green-600 mx-auto mb-4"></div>
);

export default function Modal({ modal, setModal }) {
    if (!modal) {
        return null;
    }

    // FIX: Added 'children' to the destructuring list.
    const { title, message, actions, isLoading, children } = modal;

    // Prevents closing the modal by clicking the overlay if it's a loading modal
    // or a modal that requires a specific action (has an `actions` array).
    const handleOverlayClick = () => {
        if (!isLoading && !actions) {
            // FIX: If the modal is passed an explicit onClose handler, use it.
            if (modal.onClose) {
                modal.onClose();
            } else {
                setModal(null);
            }
        }
    };

    const renderButtons = () => {
        if (isLoading) {
            return null; // No buttons on loading modals
        }

        // Case 1: Custom buttons are provided in an 'actions' array
        if (actions && actions.length > 0) {
            return actions.map((action, index) => {
                // ✅ FIX 1: Make button text backward-compatible.
                // Use 'label' if available (new standard), and fall back to 'text' (old standard).
                const buttonText = action.label || action.text || 'Confirm';

                // ✅ FIX 2: Make button style robust.
                // Use 'style' if available; otherwise, apply a default style.
                const buttonStyle = action.style || 'primary';
                let styleClasses = '';

                switch (buttonStyle.toLowerCase()) {
                    case 'danger':
                        styleClasses = 'bg-red-600 hover:bg-red-700 text-white';
                        break;
                    case 'secondary':
                        styleClasses = 'bg-gray-200 hover:bg-gray-300 text-gray-800';
                        break;
                    case 'primary':
                    default:
                        styleClasses = 'bg-green-600 hover:bg-green-700 text-white';
                        break;
                }

                return (
                    <button
                        key={index}
                        type="button"
                        onClick={action.onClick}
                        className={`w-full px-4 py-2 rounded-lg font-semibold transition ${styleClasses}`}
                    >
                        {buttonText}
                    </button>
                );
            });
        }

        // Case 2: Simple confirmation modal (no 'actions' array, uses onConfirm)
        return (
            <button
                type="button"
                onClick={() => (modal.onConfirm ? modal.onConfirm() : setModal(null))}
                className="w-full px-4 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition"
            >
                {modal.confirmText || 'Fechar'}
            </button>
        );
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4"
            onClick={handleOverlayClick}
        >
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-xl w-full max-w-md text-center" onClick={e => e.stopPropagation()}>
                {isLoading && <Spinner />}
                
                {title && <h2 className="text-2xl font-bold mb-4 text-gray-900">{title}</h2>}
                
                {/* Modal body content: Message or passed React children (e.g., PartnerForm) */}
                {(message || children) && (
                    <div className={`text-gray-700 mb-6 ${children ? 'text-left' : 'text-center'}`}>
                        {message && <p className="mb-4">{message}</p>}
                        {/* FIX: Render the children content here */}
                        {children}
                    </div>
                )}
                
                <div className="flex flex-col sm:flex-row-reverse justify-center items-center gap-3">
                    {renderButtons()}
                </div>
            </div>
        </div>
    );
}
